{
  "title": "Beneficiaries",
  "tabs": {
    "approved": "Approved",
    "pending": "Pending",
    "rejected": "Rejected"
  },
  "beneNotPayableAlert": "Please contact Client Services to activate the currency account required to make payments to this beneficiary",
  "table": {
    "searchPlaceholder": "Search beneficiaries",
    "isBenePayable": {
      "title": "Unable to pay beneficiary",
      "chip": "Currency account required"
    },
    "headers": {
      "accountName": "Entity",
      "name": "Beneficiary Name",
      "country": "Country",
      "friendlyName": "Friendly Name",
      "currency": "Currency",
      "createdDate": "Created Date",
      "rejectedDate": "Rejected Date",
      "iban": "IBAN",
      "accountDetails": "Account Details",
      "swift": "Swift",
      "action": "Action"
    },
    "dataError": "Access to view beneficiaries for the selected entities is restricted for the current user",
    "deleteError": "Access to delete this beneficiary is restricted for the current user",
    "dropdown": {
      "view": "View",
      "share": "Share",
      "delete": "Delete",
      "approveReject": "Approve/Reject",
      "update": "Update address"
    }
  },
  "structuredAddress": {
    "chip": "Update Address",
    "tooltip": "Address Information Required",
    "skipModal": {
      "title": "Missing Address Information",
      "description": "Are you sure you want to continue without updating the address? This will be required by upcoming regulations.",
      "button": {
        "skip": "Yes, Skip",
        "edit": "No, Edit Address"
      }
    },
    "drawer": {
      "shareTooltip": "Information required to share beneficiary",
      "updateTooltip": "You do not have the permissions to update the address"
    },
    "alert": {
      "title": "Beneficiaries require a structured address",
      "description": "Payment regulations now require a full structured address for all beneficiaries. If you have beneficiary inputter permissions, you can update each affected address. If not, request the change from a user who has permission.",
      "preEnforcementTitle": "Beneficiaries Need a Full Structured Address",
      "preEnforcementDescription": "Upcoming regulations will require a full structured address for beneficiaries. If you have beneficiary inputter permissions, you can update each affected address. If not, request the change from a user who has permission."
    }
  },
  "create": {
    "title": "Create Beneficiary",
    "flowTitle": "New Beneficiary",
    "successMessage": "Beneficiary submitted for approval",
    "undo": "undo",
    "genuineRequest": "Before authorising this beneficiary, please ensure that you are certain the details are correct and that the payment request is genuine.",
    "personalDetails": {
      "title": "Personal Details",
      "subtitle": "Please enter the details for the individual or company you are intending to pay.",
      "sameCurrencyFilteringAlert": "This batch contains same currency payments. Same currency payment batches can’t contain cross-currency payments. Clear the batch to add a beneficiary in a different currency as the funding account.",
      "crossCurrencyFilteringAlert": "This batch contains cross-currency payments. Cross-currency payment batches can’t contain single currency payments. Clear the batch to add a beneficiary in the same currency as the funding account.",
      "fields": {
        "entityOrGroup": {
          "label": "Add beneficiary to",
          "placeholder": "Select Entity",
          "maxAccounts": "You cannot select more than {{max}} accounts.",
          "groupsWarning": "As you have selected a group, a beneficiary will be created for all the entities where you hold the “beneficiary inputter role”, if you do not have this permission for an entity, a beneficiary will not be created.",
          "entityChip": "Entity",
          "groupChip": "Group",
          "instantApproval": "Instant Approval",
          "approvalNeeded": "Approval Needed",
          "variousPermissions": "Various Permissions",
          "variousPermissionsTooltip": "You have different approval permissions within this entity group",
          "noOptionsMessage": "No Entities/Groups Found",
          "approvalWarningCard": {
            "title": "Please note",
            "message": "When you submit the beneficiary for one or more of the selected entities, approval from another user is required to create the beneficiary."
          },
          "usRegisteredRestrictionWarning": "This entity requires different beneficiary details. It can only be selected on its own. Unselect it to add this beneficiary to others.",
          "unavailableChip": "Unavailable"
        },
        "payeeType": {
          "label": "Who are you paying?",
          "companyHeader": "Company",
          "companyDescription": "Paying a legal registered business",
          "individualHeader": "Individual",
          "individualDescription": "Paying a natural person"
        },
        "beneficiaryName": {
          "label": "Beneficiary Name",
          "placeholder": "Beneficiary Name",
          "description": "This name should match the name registered on the account you want to pay."
        },
        "friendlyName": {
          "label": "Friendly Name",
          "description": "Name to help you easily identify the beneficiary.",
          "placeholder": "Friendly Name"
        },
        "bankCountryCode": {
          "label": "Bank Country",
          "placeholder": "Select Bank Country",
          "noOptionsMessage": "No Bank Country Found"
        },
        "currencyCode": {
          "label": "Currency",
          "placeholder": "Select Currency",
          "noOptionsMessage": "No Currency Found"
        },
        "address": {
          "label": "Address"
        },
        "addressLine1": {
          "label": "Address Line 1",
          "placeholder": "Address Line 1"
        },
        "addressLine2": {
          "label": "Address Line 2",
          "placeholder": "Address Line 2"
        },
        "city": {
          "label": "City/Town",
          "placeholder": "City or Town"
        },
        "state": {
          "label": "County/State/Province",
          "placeholder": "State"
        },
        "zip": {
          "label": "Zip/Postal Code",
          "placeholder": "Postal Code"
        },
        "countryCode": {
          "label": "Country",
          "placeholder": "Select Country",
          "noOptionsMessage": "No Country Found"
        },
        "search": {
          "label": "Search for address",
          "placeholder": "Enter a postcode, city, town or number",
          "subLabel": "Results will be filtered by the country you selected."
        }
      },
      "sections": {
        "beneDetails": "Beneficiary details",
        "beneAddress": "Beneficiary address"
      },
      "beneRequiredAlert": {
        "title": "Address details are now required for beneficiaries.",
        "subtitle": "Please ensure address information is included."
      }
    },
    "bankDetails": {
      "title": "Bank Details",
      "subtitle": "Please enter the relevant bank details for this beneficiary.",
      "checkDetailsButton": "Check Details",
      "editDetailsButton": "Edit Details",
      "acceptFoundButton": "Accept found & continue",
      "continueAnywayButton": "Continue anyway",
      "cannotContinueTooltip": "Unfortunately you cannot continue with this process. Please reach out to client services.",
      "checkDetails": {
        "alert": "<0>Please note</0><1>If you choose to continue you are accepting the details may be incorrect. You should check the details before continuing. {{alertMessage}}</1><2>You could <1>lose your money</1> if you pay the wrong account.</2>",
        "alertShare": "Select 'Cancel' to resubmit and correct them.",
        "alertApprove": "Select 'Reject' to resubmit and correct them.",
        "alertCreate": "Select 'Edit details' to correct them.",
        "applyFinancial": {
          "title": "Are the details you entered correct?",
          "subtitle": "We have identified the details you have entered may contain errors. Please check the following details and correct any errors.",
          "columns": {
            "field": "Field",
            "entry": "Entry",
            "error": "Error"
          }
        },
        "match": {
          "title": "All details match",
          "subtitle": "The details of the beneficiary your sharing have been checked and match those of the beneficiary's account."
        },
        "noMatch": {
          "title": "Name does not match",
          "subtitle": "The details you have entered do not match the account you're sending money to. Please check with the beneficiary directly."
        },
        "partialMatchName": {
          "title": "Name does not match",
          "subtitle": "The details entered do not match the account of the beneficiary you’re paying. Please check with the beneficiary directly."
        },
        "partialMatchType": {
          "title": "Beneficiary type does not match",
          "subtitle": "The details entered do not match the account of the beneficiary you’re paying. Please check with the beneficiary directly."
        },
        "partialMatchBoth": {
          "title": "Name and Beneficiary type do not match",
          "subtitle": "The details entered do not match the account of the beneficiary you’re paying. Please check with the beneficiary directly."
        },
        "secondaryReferenceNeeded": {
          "title": "Unable to check details",
          "subtitle": {
            "firstParagraph": "We couldn't verify the details you entered due to the error 'Beneficiary isn't supported for Confirmation of Payee (CoP).",
            "boldSection": "This beneficiary may require secondary reference data to complete the check.",
            "secondParagraphForm": "To enter the required data, select 'Edit Details', tick the box for 'Correspondent bank details', and enter the reference in the 'Further to Account Number' field.",
            "secondParagraphApproveOrShare": "To enter the secondary reference data, delete and resubmit the beneficiary, providing the information in the 'Further to Account Number' field."
          }
        },
        "unableToCheck": {
          "title": "Unable to check details",
          "subtitle": "We can't check the details you entered, because of an error {{dynamicMessage}}. Please check with the beneficiary directly.",
          "defaultError": "Unknown reason",
          "validationError": "Validation failed",
          "errorTitle": "An error has occurred with accepting risk",
          "columns": {
            "field": "Field",
            "entry": "Entry",
            "error": "Error"
          },
          "alert": "<0>Please note</0><1>Until we are able to check the details you entered, <2>you won’t be able to add the beneficiary at this time</2>. Please address the above errors. If the problem continues or if you need any assistance, please contact Client Services.</1>"
        },
        "checkNotNeeded": {
          "title": "Beneficiary Check Not Required",
          "subtitle": "The beneficiary you are paying does not require a confirmation check at this time. You can proceed with the payment, but we recommend reviewing all details carefully before continuing to ensure accuracy."
        },
        "checkBypassed": {
          "title": "Beneficiary Check Bypassed",
          "subtitle": "The confirmation check for this beneficiary has been bypassed. You can proceed with the payment, but we recommend reviewing all details carefully before continuing to ensure accuracy."
        },
        "multiplePayeeChecks": {
          "title": "New Beneficiaries",
          "subtitle": "For any new UK beneficiaries, we automatically check the name and account details with the beneficiary bank. If something doesn't match, please click 'View detail' and correct any errors.",
          "columns": {
            "beneficiary": "Beneficiary",
            "countryAndCurrency": "Country & Currency",
            "entityName": "Entity",
            "accountDetails": "Account Details",
            "verificationCheck": "Verification Check"
          }
        },
        "checkError": {
          "subtitle": "We can’t check the details you entered because the beneficiary checking service is currently unavailable. Please try again in a few minutes.",
          "alert": "<0>Please note</0><1>Until we are able to check the details you entered, <2>you won’t be able to add the beneficiary at this time</2>. Please try again in a few minutes. If the problem continues, please contact Client Services.</1>"
        },
        "detailsSummary": {
          "accountNumber": "Account number",
          "beneName": "Beneficiary name",
          "beneType": "Beneficiary type",
          "beneTypeEntered": "Beneficiary type you entered",
          "beneTypeFound": "Beneficiary type found",
          "name": "Name",
          "nameEntered": "Name you entered",
          "nameFound": "Name found",
          "sortCode": "Sort code",
          "iban": "IBAN"
        },
        "customVOPSubtitle": {
          "match": "The details of the beneficiary you’re sending money to have been checked and match those of the beneficiary’s account.",
          "noMatch": "The details entered do not match the account of the beneficiary you’re paying. Please check with the beneficiary directly.",
          "notAvailable": "We can’t check the details entered. Please check with the beneficiary directly"
        }
      }
    },
    "review": {
      "title": "Summary",
      "subtitle": "Please review the entered details before continuing.",
      "approvalsRequired": "Approvals Required",
      "approvalsRequiredWarning": "After submission, on the following entities, the beneficiary will require approval from another user to create the beneficiary:",
      "detailsCheckedAlert": {
        "title": "Beneficiary details checked",
        "content": "Name matches the account details and the country requirements."
      }
    },
    "fraudAlert": {
      "title": "Fraud Alert",
      "nextButton": "Submit Beneficiary",
      "confirmationCheckbox": "I confirm the beneficiary details entered are correct."
    },
    "payeeCheck": {
      "title": "Beneficiaries check",
      "subtitle": "This payment batch includes new beneficiaries. Please review them carefully before approval, ensuring the details are correct and the payment request is genuine.",
      "batchSummaryTitle": "Batch Summary"
    },
    "validation": {
      "required": "This field is required",
      "specialCharacters": "Special characters are not allowed.",
      "minimumChars": "Must be {{numOfChars}} characters or more",
      "maximumChars": "Must be {{numOfChars}} characters or less",
      "countryCodeRequired": "Country code is required when an address is provided"
    },
    "mfaToast": {
      "title": "Beneficiary has been approved on {{accountNames}}",
      "body": "Number of approvals: {{numOfAccounts}}"
    },
    "errorToast": {
      "title": "Something went wrong!",
      "invalidIban": {
        "title": "The IBAN entered is invalid",
        "body": "Please check the IBAN and try again."
      }
    },
    "errors": {
      "duplicate": "The beneficiary you are creating already exists",
      "validationFailed": "Validation failed for unknown reasons."
    }
  },
  "modal": {
    "mfa": "Please select the method you would like to use to approve and add beneficiaries to entities with",
    "delete": {
      "title": "Are you sure you want to delete {{beneficiaryName}}?",
      "content": "This beneficiary will be deleted permanently. This action cannot be undone.",
      "success": "Beneficiary successfully deleted",
      "error": "Something went wrong deleting your beneficiary",
      "buttons": {
        "cancel": "Cancel",
        "confirm": "Yes, delete"
      }
    },
    "share": {
      "shareBeneficiaries": "Share Beneficiary",
      "selectAll": "Select all entities",
      "shareAnyway": "Share anyway",
      "checkAndShare": "Check and Share beneficiary"
    },
    "reject": {
      "title": "Are you sure you want to reject {{beneficiaryName}}?",
      "content": "This beneficiary will be rejected permanently. This action cannot be undone.",
      "success": "Beneficiary successfully rejected",
      "error": "Something went wrong rejecting your beneficiary"
    }
  },
  "buttons": {
    "create": "Create Beneficiary"
  },
  "drawer": {
    "chipStatus": {
      "approved": "Approved",
      "pendingApproval": "Pending Approval",
      "rejected": "Rejected"
    },
    "informationCard": {
      "pleaseNote": "Please Note",
      "noteMessage": "Before authorising this beneficiary, please ensure that you are certain the details are correct and that the payment request is genuine."
    },
    "approvalCard": {
      "approval": "Approval",
      "approved": "Approved",
      "approveButton": "Approve",
      "checkAndApprove": "Check & Approve",
      "rejectButton": "Reject"
    },
    "country": "Country",
    "currency": "Currency",
    "beneDetailsCard": {
      "type": "Beneficiary Type",
      "address": "Address",
      "bankName": "Bank Name",
      "swift": "SWIFT/BIC",
      "iban": "IBAN",
      "accountNumber": "Account Number",
      "nationalBankCode": "National Bank Code",
      "correspondentAccountNumber": "Correspondent Account Number",
      "correspondentSwift": "Correspondent SWIFT",
      "furtherToAccountNumber": "Further to Account Number",
      "furtherToSwift": "Further to SWIFT"
    },
    "beneUserDetailsCard": {
      "uploadedBy": "Uploaded By",
      "approvedBy": "Approved By",
      "rejectedBy": "Rejected By"
    },
    "shareBeneButton": "Share Beneficiary",
    "deleteBeneButton": "Delete Beneficiary",
    "updateBeneButton": "Update Address"
  },
  "bankDetails": {
    "tabs": {
      "international": "International",
      "local": "Local"
    },
    "correspondentBankDetails": {
      "checkbox": "Does this beneficiary have correspondent bank details?",
      "correspondentAccountNumber": {
        "label": "Correspondent Account Number",
        "placeholder": "Enter Account Number"
      },
      "correspondentSwift": {
        "label": "Correspondent SWIFT",
        "placeholder": "Enter SWIFT/BIC",
        "validation": "Correspondent SWIFT cannot match Beneficiary SWIFT",
        "required": "Correspondent SWIFT/BIC is required when a correspondent account number is provided."
      },
      "furtherToAccountNumber": {
        "label": "Further To Account Number",
        "placeholder": "Enter Account Number",
        "required": "Further To Account Number is required when a Further To SWIFT/BIC is provided."
      },
      "furtherToSwift": {
        "label": "Further to SWIFT",
        "placeholder": "Enter SWIFT/BIC"
      }
    },
    "beneficiaryCurrency": "Beneficiary Currency",
    "beneficiaryBankCountry": "Beneficiary Bank Country",
    "oneBankFieldRequired": "To send <1>{{selectedTranslatedTab}}</1> money to <3>{{country}}</3> you will need the following information:",
    "bothBankFieldsWarning": "You have selected entities that have different jurisdictions. To create this beneficiary, you will require both international and local account details.",
    "swiftInfo": "<0>A SWIFT / BIC (SWIFT Business Identifier Code) identifies the overseas bank you're sending payments to.</0><2>To accurately send payments to the beneficiary bank, ensure the correct SWIFT / BIC is provided.</2>",
    "accountNumberValidationError": "{{field}} is too long, do not exceed 50 characters.",
    "swiftValidationError": "{{field}} must be 8 or 11 digits.",
    "swiftBicValidationError": "SWIFT / BIC must be 8 or 11 digits.",
    "ibanValidationError": "The IBAN is invalid. Please check the IBAN entered and try again.",
    "swiftToCorrespondentSwiftValidation": "Beneficiary SWIFT cannot match Correspondent SWIFT",
    "placeholder": "Input {{field}}"
  },
  "continueAnyway": "Continue anyway",
  "approveAnyway": "Approve anyway",
  "approveBeneficiary": "Approve beneficiary",
  "checkGenericError": "Couldn't check or approve beneficiary",
  "unknownEntityTypeAlert": {
    "action": "This beneficiary can’t be actioned because some details are missing. Please add the beneficiary again.",
    "approve": "This beneficiary can’t be approved because some details are missing. Please reject or delete it, then add the beneficiary again.",
    "check": "This beneficiary's details can’t be checked because some details are missing. Please reject or delete it, then add the beneficiary again.",
    "share": "This beneficiary can’t be shared because some details are missing. Please reject or delete it, then add the beneficiary again.",
    "unableToShare": "Unable to share beneficiary"
  },
  "shareModal": {
    "structuredAddressRequired": {
      "chip": "Sharing unavailable",
      "tooltip": "Beneficiaries with unstructured addresses cannot be shared to this entity."
    }
  },
  "addressUpdateModal": {
    "title": "Update Beneficiary Address",
    "subtitle": "Enter and confirm beneficiary address details below.",
    "alert": {
      "payments": {
        "required": {
          "title": "Address Information Required",
          "content": "This beneficiary requires a complete address before the payment can continue. Please provide the address details below."
        },
        "skippable": {
          "title": "Beneficiary address requires updating",
          "content": "Upcoming payment regulations will require each part of an address to be saved separately. Re-enter the address below. Payments may be rejected in future if this is not completed."
        },
        "noPermission": {
          "title": "Update beneficiary address",
          "content": "Upcoming payment regulations will require updated beneficiary addresses. Payments may be rejected in future without them. You don't have permission to update beneficiary addresses, please contact another user who can make this change."
        },
        "noPermissionBlocked": {
          "title": "Update beneficiary address",
          "content": "This beneficiary does not meet regulatory address requirements to be sent. You don't have permission to update beneficiary addresses, please contact another user who can make this change."
        }
      },
      "beneficiaries": {
        "required": {
          "title": "Update Beneficiary Address",
          "content": "Regulations now require each part of an address to be saved separately. Payments to this beneficiary may be rejected until the address is updated. If an address has previously been provided, please re-enter it below."
        },
        "skippable": {
          "title": "Beneficiary address requires updating",
          "content": "Upcoming payment regulations will require each part of an address to be saved separately. Re-enter the address below. Payments may be rejected in future if this is not completed."
        },
        "noPermission": {
          "title": "Update beneficiary address",
          "content": "Upcoming payment regulations will require updated beneficiary addresses. Payments may be rejected in future without them. You don't have permission to update beneficiary addresses, please contact another user who can make this change."
        },
        "noPermissionBlocked": {
          "title": "Update beneficiary address",
          "content": "This beneficiary does not meet regulatory address requirements to be sent. You don't have permission to update beneficiary addresses, please contact another user who can make this change."
        }
      }
    },
    "toast": {
      "success": {
        "title": "Address Updated",
        "body": "The beneficiary address has been updated successfully."
      },
      "error": {
        "title": "Update Failed",
        "body": "Failed to update the beneficiary address. Please try again."
      },
      "alreadyExists": {
        "title": "Beneficiary already exists",
        "body": "A beneficiary with these details already exists."
      }
    },
    "buttons": {
      "confirmAddress": "Confirm Address",
      "confirmAndContinue": "Confirm & Continue"
    },
    "beneficiaryDetails": {
      "title": "Existing Beneficiary Details",
      "entity": "Entity",
      "friendlyName": "Friendly Name",
      "currency": "Currency",
      "currentAddress": "Current Address"
    },
    "addressForm": {
      "title": "Address Details",
      "fields": {
        "country": {
          "label": "Country",
          "placeholder": "Select Country"
        },
        "search": {
          "label": "Search for address",
          "placeholder": "Enter a postcode, city, town or number",
          "subLabel": "Results will be filtered by the country you selected."
        },
        "addressLine1": {
          "label": "Address Line 1",
          "placeholder": "Enter Address Line 1"
        },
        "addressLine2": {
          "label": "Address Line 2",
          "placeholder": "Enter Address Line 2"
        },
        "city": {
          "label": "City/Town",
          "placeholder": "Enter City or Town"
        },
        "state": {
          "label": "County/State/Province",
          "placeholder": "Enter State"
        },
        "zip": {
          "label": "Zip/Postal Code",
          "placeholder": "Enter Postal Code"
        }
      }
    },
    "addressSearch": {
      "label": "Address",
      "placeholder": "Enter address",
      "noResults": "No results found",
      "typeAtLeast": "Type at least {{minSearchLength}} letters to begin searching"
    }
  }
}
